import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";

/**
 * One drawn filter box (label over value, `SeasonRecord.dc.html`). Moved out of
 * `SeasonRecordScreen.jsx` unchanged so the Dashboard screen (#1147) draws the
 * same three boxes.
 */
export default function FilterBox({ testId, label, value, onChange, options = [], allLabel }) {
  const display = value === "all" ? allLabel : value;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testId}
        className="border-[var(--nw-line)]"
        style={{
          flex: 1,
          minHeight: 44,
          padding: "0 10px",
          background: "var(--nw-surface)",
          border: "1px solid var(--nw-line)",
          borderRadius: "var(--nw-radius-control)",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", minWidth: 0, alignItems: "flex-start" }}>
          <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--nw-ink-muted)" }}>
            {label}
          </span>
          <span style={{ fontSize: 13, fontWeight: 600, color: "var(--nw-ink)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {display}
          </span>
        </div>
      </SelectTrigger>
      <SelectContent>
        {/* B1 (PR #880 review) — the dropdown's OWN "all" row stays
            descriptive ("All seasons"/"All competitions"/"All teams",
            derived from `label`, journey 37's own established wording),
            never the shorter `allLabel` the collapsed trigger shows
            (`display` above) — that one's compact form exists for its
            OWN space constraint (a 44px-tall three-box row), not because
            the dropdown needs the same brevity once actually open. Fixed
            precisely: only `allLabel` itself no longer carries the drawn
            "[SEASON]" placeholder (it is "All seasons" now, a real
            label) — this list item was never the thing B1 flagged. */}
        <SelectItem value="all">{`All ${label.toLowerCase()}s`}</SelectItem>
        {options.map((o) => (
          <SelectItem key={o} value={o}>
            {o}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
